"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sticky_note = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const sticky_note = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'sticky-note-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4.75 5.70233V16.2023H11.25V12.9523C11.25 12.5381 11.5858 12.2023 12 12.2023H15.25V5.70227L4.75 5.70233ZM15.1893 13.7023H12.75V16.1416L15.1893 13.7023ZM4 4.20233L16 4.20227C16.1989 4.20227 16.3897 4.28129 16.5303 4.42194C16.671 4.56259 16.75 4.75336 16.75 4.95227V13.9523C16.75 14.1512 16.671 14.3419 16.5303 14.4826L13.5303 17.4826C13.3897 17.6233 13.1989 17.7023 13 17.7023H4C3.58579 17.7023 3.25 17.3665 3.25 16.9523V4.95233C3.25 4.53812 3.58578 4.20234 4 4.20233Z', fill: '#4B5563' })));
};
exports.sticky_note = sticky_note;
